import { Button } from "@/components/ui/button";
import { Phone, Crown, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const Navigation = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const interval = setInterval(() => setShowPhone(prev => !prev), 3000);
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => {
      clearInterval(interval);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    if (isHome) {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
  };

  // Handle hash scroll after navigation to home
  useEffect(() => {
    if (isHome && location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location, isHome]);

  const navLinks = [
    { label: "O nas", id: "about" },
    { label: "Oferta", id: "offer" },
    { label: "Dlaczego warto?", id: "benefits" },
    { label: "Dlaczego my?", id: "why-us" },
    { label: "Kontakt", id: "kontakt" },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled || !isHome ? "bg-primary/95 backdrop-blur-md shadow-lg shadow-black/20 py-3" : "bg-transparent py-5"
    }`}>
      <div className="container mx-auto px-4 flex justify-between items-center">
        <a href="/" className="text-xl font-montserrat font-bold text-white flex items-center gap-2 hover:scale-105 transition-transform">
          <Crown className="w-7 h-7 text-accent" />
          <span>WystepFirmowy<span className="text-accent">.pl</span></span>
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex gap-1 items-center">
          {navLinks.map((link) => (
            <button 
              key={link.id}
              onClick={() => scrollToSection(link.id)} 
              className="text-white/70 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all text-sm font-medium"
            >
              {link.label}
            </button>
          ))}
          <Button 
            onClick={() => window.location.href = "tel:+48533333993"}
            className="ml-2 bg-accent hover:bg-accent-light text-white w-[180px] transition-all duration-300 flex items-center justify-center gap-2 rounded-xl"
          >
            {showPhone ? (
              <>
                <Phone className="w-4 h-4" />
                +48 533 333 993
              </>
            ) : (
              "Zamów występ"
            )}
          </Button>
        </div>

        {/* Mobile menu button */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden text-white p-2">
          {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-primary/98 backdrop-blur-md border-t border-white/5">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <button 
                key={link.id}
                onClick={() => scrollToSection(link.id)} 
                className="text-white/70 hover:text-white py-3 px-4 text-left rounded-lg hover:bg-white/5 transition-all"
              >
                {link.label}
              </button>
            ))}
            <Button 
              onClick={() => window.location.href = "tel:+48533333993"}
              className="bg-accent hover:bg-accent-light text-white mt-2 rounded-xl"
            >
              <Phone className="w-4 h-4 mr-2" />
              +48 533 333 993
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};
